var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5419_7559",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 11
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.392578,
    y: 0.102539,
    width: 10.7279,
    height: 10.7279,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5419_7559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75566 7.25458L3.52068 5.0196L4.14647 4.37146L5.30866 5.53365V1.89062H6.20266V5.53365L7.36485 4.37146L7.99064 5.0196L5.75566 7.25458ZM3.07368 9.04257C2.82783 9.04257 2.61737 8.95503 2.4423 8.77996C2.26722 8.60488 2.17969 8.39442 2.17969 8.14858V6.80759H3.07368V8.14858H8.43764V6.80759H9.33163V8.14858C9.33163 8.39442 9.24409 8.60488 9.06902 8.77996C8.89395 8.95503 8.68349 9.04257 8.43764 9.04257H3.07368Z",
    fill: "#2D2F31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.7ccfb04186b7cf6b01116eae9c45bfb0.svg";
export { ForwardRef as ReactComponent };